import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Campaings {
	/** @GET /pages/:uid/campaings
	 * Obtiene todas las campañas de la página
	 */
	async getAllCampaings(pgid: string, params: { take?: number; skip?: number }, token: string) {
		let p = { params: btoa(JSON.stringify(params)) };
		let response = await xget<{ campaings: PGSchema.campaigns[] }>(`/pages/${pgid}/campaings`, { params: p }, { headers: { "app-token": token } });
		return response;
	}

	/** @POST /pages/:uid/campaings
	 * Crea una nueva campaña
	 */
	async createCampaing(pgid: string, body: Omit<PGSchema.campaigns, "id" | "pgid" | "created_at" | "updated_at" | "created_by">, token: string) {
		let response = await xhttp<{ campaing: PGSchema.campaigns }>(`/pages/${pgid}/campaings`, "POST", body, { headers: { "app-token": token } });
		return response;
	}

	/** @GET /pages/:uid/campaings/:id
	 * Obtiene una campaña específica
	 */
	async getCampaing(pgid: string, id: string, token: string) {
		let response = await xget<{ campaing: PGSchema.campaigns }>(`/pages/${pgid}/campaings/${id}`, {}, { headers: { "app-token": token } });
		return response;
	}

	/** @PUT /pages/:uid/campaings/:id
	 * Edita una campaña existente
	 */
	async editCampaing(pgid: string, id: string, body: Partial<Omit<PGSchema.campaigns, "id" | "pgid" | "created_at" | "updated_at" | "created_by">>, token: string) {
		let response = await xhttp<{ updated: number }>(`/pages/${pgid}/campaings/${id}`, "PUT", body, { headers: { "app-token": token } });
		return response;
	}

	/** @DELETE /pages/:uid/campaings/:id
	 * Borra una campaña
	 */
	async deleteCampaing(pgid: string, id: string, token: string) {
		let response = await xhttp<{ deleted: PGSchema.campaigns }>(`/pages/${pgid}/campaings/${id}`, "DELETE", {}, { headers: { "app-token": token } });
		return response;
	}
}
